const face = {
  state: {
    faceId:0,
    faceBasicMessageFirst: [], // 步骤1的第一部分填写的信息
    faceBasicMessageSecond: [], // 步骤1的第二部分填写的信息
    faceChapter: [], // 步骤2的课件的章节
    facepushRange: [] // 步骤3的发布的范围
  },
  getters: {
    faceId: state => {
      return state.faceId
    },
    faceBasicMessageFirst: state => {
      return state.faceBasicMessageFirst
    },
    faceBasicMessageSecond: state => {
      return state.faceBasicMessageSecond
    },
    faceChapter: state => {
      return state.faceChapter
    },
    facepushRange: state => {
      return state.facepushRange
    }
  },
  mutations: {
    SET_FACE_ID(state, faceId) {
      state.faceId = faceId
    },
    SET_FACE_BASICMESSAGE_FIRST(state, faceBasicMessageFirst) {
      state.faceBasicMessageFirst = faceBasicMessageFirst
    },
    SET_FACE_BASICMESSAGE_SECOND(state, faceBasicMessageSecond) {
      state.faceBasicMessageSecond = faceBasicMessageSecond
    },
    SET_FACE_CHAPTER (state, faceChapter) {
      state.faceChapter = faceChapter
    },
    SET_FACE_PUSHRANGE (state, facepushRange) {
      state.facepushRange = facepushRange
    }
  },
  actions: {}
}

export default face



// WEBPACK FOOTER //
// ./src/store/modules/face.js